import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
import { ListenHelpCard } from '../../components/student/ListenHelpCard';
const packages = [{
  name: '3-Class Renewal Package (select your own courses-9 hours)',
  credits: 9,
  price: '$49.95'
}, {
  name: '3-Class Broker Management Clinic (Preset with BMC 1-2-3 for 9 hours)',
  credits: 9,
  price: '$54.95',
  hasDetails: true
}, {
  name: '3-Class Property Management BMC (Preset with BMC 1-2-3B for 9 hours)',
  credits: 9,
  price: '$54.95',
  hasDetails: true
}, {
  name: '6-Class Salesperson Renewal Package (select your own courses-18 hours)',
  credits: 18,
  price: '$69.95'
}, {
  name: '6-Class FIRST TIME Renewal Package (Preset -18 Hours)',
  credits: 18,
  price: '$69.95'
}, {
  name: '#1 8-Class Salesperson Renewal Package (Preset-24 hours)',
  credits: 24,
  price: '$89.95',
  hasDetails: true
}, {
  name: '#2 8-Class Salesperson Renewal Package (Preset-24 hours with NAR Ethics)',
  credits: 24,
  price: '$89.95',
  hasDetails: true
}, {
  name: '10-class Broker Renewal Package (Preset-30 hours with NAR Ethics)',
  credits: 30,
  price: '$104.95',
  hasDetails: true
}, {
  name: '10-Class Renewal Package for Property Management Brokers (Preset 30-hours with NAR Ethics and BMC #3B)',
  credits: 30,
  price: '$104.95',
  hasDetails: true
}];
const singleClasses = [{
  name: 'Ethics & The Rules (with NAR Code of Ethics)',
  creditType: 'Comm. Standards',
  credits: 3,
  description: "CS CE credit + Complies with current NAR cycle January 2025-December 2027 The Commissioner's",
  price: '$19.95'
}, {
  name: 'NAR Code of Ethics (NO CE CREDIT)',
  creditType: 'NONE',
  credits: 0,
  description: '(No CE Credit - No Clock Hours) Complies with current cycle January 2025-December 2027 REMEMBER-SEND',
  price: '$14.95'
}, {
  name: 'Deeds, Fires & Water: Be Prepared',
  creditType: 'General',
  credits: 3,
  description: 'Deeds, Fires & Water: Be Prepared (GEN) Our obligation to protect the public through awareness of deed fraud',
  price: '$19.95'
}, {
  name: 'Are They Represented?',
  creditType: 'Agency Law',
  credits: 3,
  description: 'Are They Represented? (AL) This class will explore the history of agency disclosure, from sub agency',
  price: '$19.95'
}, {
  name: 'Mastering Agency Agreements',
  creditType: 'Agency Law',
  credits: 3,
  description: 'Mastering Agency Agreements (AL) Objective: Class will review the way real estate agency',
  price: '$19.95'
}, {
  name: 'A Letter From ADRE',
  creditType: 'Comm. Standards',
  credits: 3,
  description: 'A Letter From ADRE (CS) This course will review both the Arizona Revised Statutes and',
  price: '$19.95'
}, {
  name: "Don't Lose Your License",
  creditType: 'Comm. Standards',
  credits: 3,
  description: "Don't Lose Your License (CS) This class will look at various parts of the Arizona Revised Statutes",
  price: '$19.95'
}, {
  name: 'BMC #1 AZ Residential-Statutes and Rules',
  creditType: 'Comm. Standards',
  credits: 3,
  description: 'BMC#1 AZ Residential Statutes & Rules (CS) This is part 1 of the 3 required, 9 hour Broker Management',
  price: '$19.95'
}, {
  name: 'BMC #2 AZ Residential-Broker Policies',
  creditType: 'Comm. Standards',
  credits: 3,
  description: 'BMC#2 AZ Residential Broker Policies (CS) This is part 2 of the 3 required, 9 hour Broker Management Clinic required',
  price: '$19.95'
}, {
  name: 'BMC #3 AZ Residential-Broker Supervision',
  creditType: 'Comm. Standards',
  credits: 3,
  description: 'BMC#3 AZ Residential Broker Supervision (CS) This is part 3 of the 3 required, 9 hour Broker Management',
  price: '$19.95'
}, {
  name: 'BMC #3B Property Management',
  creditType: 'Comm. Standards',
  credits: 3,
  description: 'Broker Management Clinic #3B Property Management (CS) If the broker conducts or allows PROPERTY',
  price: '$19.95'
}, {
  name: 'What Goes Wrong In Contracts',
  creditType: 'Contract Law',
  credits: 3,
  description: 'What Goes Wrong In Contracts? (CL) A review of the common contract issues in residential',
  price: '$19.95'
}, {
  name: 'Avoid The Oops: Contract Smarts for Agents',
  creditType: 'Contract Law',
  credits: 3,
  description: 'Avoid The Oops: Contract Smarts For Agents (CL) A review of a valid, enforceable',
  price: '$19.95'
}];
export function StudentDashboard() {
  const navigate = useNavigate();
  return <div className="space-y-8" data-id="element-2377" data-mp="110f68bmm9hru">
      {/* Page Title */}
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-2378" data-mp="10yubom0axytz">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-2379" data-mp="1g2x37kdyoo4h">
          On-Demand Classes
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-2380" data-mp="1b5ogd6hvbvww">
          Browse packages and individual courses for your continuing education.
        </p>
      </div>

      {/* Requirement Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2381" data-mp="1k4s5ar3pv5jb">
        <Card className="border-slate-200" data-id="element-2382" data-mp="1k3gysjivzjoi">
          <div className="p-5" data-id="element-2383" data-mp="1ytepb64aglgv">
            <h2 className="text-sm font-bold text-slate-800 mb-1" data-id="element-2384" data-mp="1ysd4wb1dummh">
              Salesperson / Associate Broker Requirements
            </h2>
            <p className="text-sm font-semibold mb-2" style={{
            color: '#4A2D8F'
          }} data-id="element-2385" data-mp="27umcot59o1w6">
              24 hours every 2-year renewal cycle
            </p>
            <p className="text-xs text-slate-600 leading-relaxed" data-id="element-2386" data-mp="dg3e31nuiijf">
              <span className="font-semibold text-slate-700" data-id="element-2387" data-mp="9f9ps76hr1q0">Required CE:</span>{' '}
              Agency Law, Contract Law, Disclosure, Fair Housing, Real Estate
              Legal Issues, Requirements for Licensees (formerly Commissioner's
              Standards/Rules), Firewise / Deed Fraud / Arizona Water, plus
              Elective hours.
            </p>
          </div>
        </Card>
        <Card className="border-slate-200" data-id="element-2388" data-mp="2nhai27qz76sr">
          <div className="p-5" data-id="element-2389" data-mp="2nibxspixshgt">
            <h2 className="text-sm font-bold text-slate-800 mb-1" data-id="element-2390" data-mp="2nf7hwuw3zxab">
              Broker Requirements
            </h2>
            <p className="text-sm font-semibold mb-2" style={{
            color: '#4A2D8F'
          }} data-id="element-2391" data-mp="2whyx95s3vd78">
              30 hours every 2-year renewal cycle
            </p>
            <p className="text-xs text-slate-600 leading-relaxed mb-2" data-id="element-2392" data-mp="368bdwmwsum83">
              For Designated, Self-employed, and Delegated Associate Brokers.
              Includes Broker Management Clinic (BMC) courses plus the
              required/elective CE categories below.
            </p>
            <p className="text-xs text-slate-600 leading-relaxed" data-id="element-2393" data-mp="13kv1qbbxbng7">
              <span className="font-semibold text-slate-700" data-id="element-2394" data-mp="13j0eurh3dl9h">Required CE:</span>{' '}
              Agency Law, Contract Law, Disclosure, Fair Housing, Legal Issues,
              Requirements for Licensees (formerly Commissioner's
              Standards/Rules), General / Deed Fraud, Firewise, AZ Water, BMC 1,
              BMC 2, BMC 3 or BMC 3B (for Property Management), plus Elective
              hours as needed.
            </p>
          </div>
        </Card>
      </div>

      {/* Listen instead of read help */}
      <ListenHelpCard data-id="element-2395" data-mp="1djaqi7nhakmj" />

      {/* On-Demand Packages */}
      <div data-id="element-2396" data-mp="1dhpvyi15z1oo">
        <h2 className="text-lg font-semibold text-slate-800 mb-3" data-id="element-2397" data-mp="1dhg8b13ld6m5">
          On-Demand Packages
        </h2>
        <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-2398" data-mp="18i3jiat5tpgx">
          <div className="overflow-x-auto" data-id="element-2399" data-mp="2616ci29o5jsl">
            <table className="w-full text-sm text-left" data-id="element-2400" data-mp="218v92pfpzfva">
              <thead style={{
              backgroundColor: '#4A2D8F'
            }} className="text-white font-medium" data-id="element-2401" data-mp="217ajzfc6cp4t">
                <tr data-id="element-2402" data-mp="1ed263wqv54y0">
                  <th className="px-4 py-3 border-r border-purple-700" data-id="element-2403" data-mp="1edbnwx1r85sm">
                    Package Name
                  </th>
                  <th className="px-3 py-3 border-r border-purple-700 text-center w-24" data-id="element-2404" data-mp="10isv9dbm4gni">
                    Credit Hours
                  </th>
                  <th className="px-3 py-3 border-r border-purple-700 text-center w-20" data-id="element-2405" data-mp="1scuxlua7rp71">
                    Price
                  </th>
                  <th className="px-3 py-3 text-center w-28" data-id="element-2406" data-mp="1x8satrq6kffl">Purchase</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200" data-id="element-2407" data-mp="1oa6l9cmak05b">
                {packages.map((pkg, i) => <tr key={i} className="hover:bg-purple-50/30" data-id="element-2408" data-mp="7vydio66jvdq" data-mpi={i}>
                    <td className="px-4 py-2.5 border-r border-slate-200" data-id="element-2409" data-mp="7un86jx36fki">
                      <span className="text-slate-800" data-id="element-2410" data-mp="cvt22l2hg8vm">{pkg.name}</span>
                      {pkg.hasDetails && <button className="ml-1 text-blue-600 hover:underline text-xs" data-id="element-2411" data-mp="4c7l5fmdjnm8">
                          Details
                        </button>}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-2412" data-mp="ebf9syyk74on">
                      {pkg.credits}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center font-medium" style={{
                  color: '#CC0000'
                }} data-id="element-2413" data-mp="3hsdxdj17lb7v">
                      {pkg.price}
                    </td>
                    <td className="px-3 py-2.5 text-center" data-id="element-2414" data-mp="3mri6yas1payq">
                      <button className="px-3 py-1 text-white text-xs font-bold rounded" style={{
                    backgroundColor: '#2E7D32'
                  }} data-id="element-2415" data-mp="3mpxd6ndk1w1x">
                        BUY NOW
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>

      {/* On-Demand Single Classes */}
      <div data-id="element-2416" data-mp="2uis0dvw6brln">
        <h2 className="text-lg font-semibold text-slate-800 mb-3" data-id="element-2417" data-mp="2uii79zfu14bq">
          On-Demand Single Classes
        </h2>
        <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-2418" data-mp="2lfqx02yp0elo">
          <div className="overflow-x-auto" data-id="element-2419" data-mp="2li3jmtfebd52">
            <table className="w-full text-sm text-left" data-id="element-2420" data-mp="2gp0owhyvtxna">
              <thead style={{
              backgroundColor: '#4A2D8F'
            }} className="text-white font-medium" data-id="element-2421" data-mp="2gnfucsckiepf">
                <tr data-id="element-2422" data-mp="26sxophnlc92z">
                  <th className="px-4 py-3 border-r border-purple-700 w-44" data-id="element-2423" data-mp="26p9vkjm25oos">
                    Class Name
                  </th>
                  <th className="px-3 py-3 border-r border-purple-700 w-28" data-id="element-2424" data-mp="1xpwn9u9o765n">
                    Credit Type
                  </th>
                  <th className="px-3 py-3 border-r border-purple-700 text-center w-16" data-id="element-2425" data-mp="d7ue9lswy7bg">
                    Credit Hours
                  </th>
                  <th className="px-4 py-3 border-r border-purple-700" data-id="element-2426" data-mp="m929tw41ou1u">
                    Description
                  </th>
                  <th className="px-3 py-3 border-r border-purple-700 text-center w-20" data-id="element-2427" data-mp="r8ezeomawf84">
                    Price
                  </th>
                  <th className="px-3 py-3 text-center w-28" data-id="element-2428" data-mp="3prltwbckktlk">Purchase</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200" data-id="element-2429" data-mp="3umj2jh5xt0xx">
                {singleClasses.map((cls, i) => <tr key={i} className="hover:bg-purple-50/30" data-id="element-2430" data-mp="89at3nm58zk5" data-mpi={i}>
                    <td className="px-4 py-2.5 border-r border-slate-200 font-medium text-slate-800" data-id="element-2431" data-mp="8alvbizxxz95">
                      {cls.name}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-slate-600" data-id="element-2432" data-mp="3bxm7vc6mo6f6">
                      {cls.creditType}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-2433" data-mp="33vljx2sv66s6">
                      {cls.credits}
                    </td>
                    <td className="px-4 py-2.5 border-r border-slate-200 text-slate-600 text-xs leading-relaxed" data-id="element-2434" data-mp="3dnrcadn12q7w">
                      {cls.description}{' '}
                      <button className="text-blue-600 hover:underline" data-id="element-2435" data-mp="38qr704y05rhu">
                        More &gt;
                      </button>
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center font-medium" style={{
                  color: '#CC0000'
                }} data-id="element-2436" data-mp="2gytfyqzmqk8m">
                      {cls.price}
                    </td>
                    <td className="px-3 py-2.5 text-center" data-id="element-2437" data-mp="a57slzif0sop">
                      <button className="px-3 py-1 text-white text-xs font-bold rounded" style={{
                    backgroundColor: '#2E7D32'
                  }} data-id="element-2438" data-mp="587lrmdqrlwj">
                        BUY NOW
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </div>;
}